import { Activity, ActivityUser } from 'types/interfaces/activity';

/** All of one user's activity items, plus derived group-level summary fields. */
export interface ActivityUserGroup {
  user: ActivityUser;
  activities: Activity[];
  count: number;
  /** Sum of every item's pointValue (nulls treated as 0). */
  totalPoints: number;
  /** Most recent createdAt in the group — the group's sort key + header time. */
  mostRecent: string;
}

/**
 * Collapse the (already loaded) activity feed into per-user groups for the by-trader view.
 * Groups are ordered by their most-recent item (desc) so a fresh item resurfaces its
 * trader to the top; within a group items keep the feed's chronological order.
 */
export const groupActivityByUser = (activities: Activity[]): ActivityUserGroup[] => {
  const byId = new Map<number, ActivityUserGroup>();
  const order: number[] = [];
  for (const activity of activities) {
    const id = activity.user.id;
    let group = byId.get(id);
    if (!group) {
      group = {
        user: activity.user,
        activities: [],
        count: 0,
        totalPoints: 0,
        mostRecent: activity.createdAt,
      };
      byId.set(id, group);
      order.push(id);
    }
    group.activities.push(activity);
    group.count += 1;
    group.totalPoints += activity.pointValue ?? 0;
    if (activity.createdAt > group.mostRecent) group.mostRecent = activity.createdAt;
  }
  return order
    .map((id) => byId.get(id) as ActivityUserGroup)
    .sort((a, b) => b.mostRecent.localeCompare(a.mostRecent));
};
